module.exports = __webpack_public_path__ + "img/currentLocation.87b86498.svg";